export default __webpack_public_path__ + "static/media/container.3f0ae851.png";